import { Controller } from "stimulus";

export default class extends Controller {
  scrollTo(event) {
    event.preventDefault();

    const headerHeight = 150;
    const targetId = event.currentTarget.getAttribute('href')
    const targetElement = document.querySelector(targetId);

    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }
}
